<template>
  <div class="pb-2" style="height: 95%;">

    <n-button icon type="primary" round size="lg" social @click.native="showWritePostModal" style="top: auto;inset-inline-end: 10px;bottom: 4rem;inset-inline-start: auto;position: fixed;z-index: 999;" float>
      <i class="fas fa-pen"></i>
    </n-button>

    <div class="col-12 pl-4 pr-4 mb-3">
      <cool-select v-if="SHOW_SEARCH_BAR" class="custom-input" :placeholder="$t('message.Search topics you are interested in')" :items="[]" v-model="selectedForum" @search="searchForumDebounce" @keyup="coolSelectOnKeyUp" :resetSearchOnBlur="false" ref="forumSearch">
        <template #no-data>
          {{ "" }}
        </template>
      </cool-select>
    </div>
    <div style="height: calc(100% - 0em - 1.5rem);">
      <div style="height: 100%; overflow:scroll;" class="pb-5">
        <div class="col-12 p-0" v-for="forumPost in forumPosts" :key="forumPost._id">
          <forum-post :post="forumPost" :type="'post'" @post-deleted="onPostDelete" @edit-post="onEditPost"></forum-post>
        </div>

        <infinite-loading spinner="waveDots" @infinite="getForumPosts" :identifier="searchString">
          <span slot="no-more">{{ forumPosts && forumPosts.length ? $t('message.No more posts'): $t('message.No posts found at the moment')}}</span>
          <span slot="no-results">
            <p><i style="color: gray; padding-right: 0.5em;" class="fa fa-file-invoice"></i> {{ $t('message.No posts found at the moment') }} </p>
          </span>
        </infinite-loading>
      </div>

    </div>

    <!-- Write post modal-->
    <modal :show.sync="SHOW_WRITE_POST_MODAL" headerClasses="d-none" class="write-post-modal" footerClasses="justify-content-center d-none" modalContentClasses="write-post-modal-content" :showClose="false" :animationDuration="250" @close="closeWritePostModal">
      <create-forum-post v-if="SHOW_WRITE_POST_MODAL" :type="'Post'" @forumPostCreated="onPostCreation" @cancel="closeWritePostModal"></create-forum-post>
      <template slot="footer">
      </template>
    </modal>

    <!-- edit modal-->
    <modal :show.sync="SHOW_EDIT_POST_MODAL" headerClasses="d-none" class="write-post-modal" footerClasses="justify-content-center" modalContentClasses="write-post-modal-content" :showClose="false" :animationDuration="250" @close="closeWritePostModal">
      <create-forum-post v-if="SHOW_EDIT_POST_MODAL" :type="'Post'" :updatePost="updatePost" @forumPostCreated="onPostCreation" @cancel="SHOW_EDIT_POST_MODAL = false; onPostDelete()"></create-forum-post>
      <template slot="footer">
      </template>
    </modal>
  </div>
</template>

<script>
import ForumPost from "./ForumPost.vue";
import CreateForumPost from "./CreateForumPost.vue";
import { debounce } from "../../../../services/debounce.service";

export default {
  name: "forum",
  components: {
    ForumPost,
    CreateForumPost,
  },
  data() {
    return {
      hasForms: false,
      SHOW_WRITE_POST_MODAL: false,
      SHOW_EDIT_POST_MODAL: false,
      updatePost: {},
      forumPosts: [],
      selectedForum: null,
      searchString: "",

      forumPostsPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 10,
      },
    };
  },
  async mounted() {
    // clear reply routing stack
    this.$store.state.postRouteStack = [];
    this.$store.state.forumPostCache = {};
    this.getForumPostDataFromStore();
  },

  created() {
    this.searchForumDebounce = debounce(this.searchForum, 400);
  },
  methods: {
    async onPostCreation() {
      this.SHOW_EDIT_POST_MODAL = false;
      this.SHOW_WRITE_POST_MODAL = false;
      this.forumPosts = [];
      this.forumPostsPagination.pageNumber = 1;
      await this.getForumPosts();
    },
    showWritePostModal() {
      this.SHOW_WRITE_POST_MODAL = true;
    },
    closeWritePostModal() {
      this.SHOW_WRITE_POST_MODAL = false;
    },

    coolSelectOnKeyUp(event) {
      if (event.key == "Enter") {
        this.$refs.forumSearch.$el.querySelector("input").blur();
      }
    },

    searchForum(searchStr) {
      this.forumPosts = [];
      this.resetPagination();
      this.searchString = searchStr;
    },

    resetPagination() {
      this.forumPostsPagination = {
        pageNumber: 1,
        totalPages: 0,
        pageSize: this.forumPostsPagination.pageSize,
      };
    },

    setForumPostDataInStore() {
      this.$store.commit("setState", {
        stateName: "forumPosts",
        stateValue: {
          forumPosts: this.forumPosts,
          forumPostsPagination: this.forumPostsPagination,
        },
      });
    },
    getForumPostDataFromStore() {
      // get forum posts from store
      let forumPostData = this.$store.state.forumPosts;
      if (forumPostData) {
        this.forumPosts = forumPostData.forumPosts;
        this.forumPostsPagination = forumPostData.forumPostsPagination;
      }
    },

    async getSearchedPosts() {
      return await this.$store.dispatch("searchForumPost", {
        pageNumber: this.forumPostsPagination.pageNumber,
        pageSize: this.forumPostsPagination.pageSize,
        searchStr: this.searchString,
      });
    },
    async getAllPosts() {
      return await this.$store.dispatch("getForumPosts", {
        pageNumber: this.forumPostsPagination.pageNumber,
        pageSize: this.forumPostsPagination.pageSize,
      });
    },

    onPostDelete() {
      this.forumPosts = [];
      this.searchString = "";
      this.resetPagination();
      this.getForumPosts();
    },

    onEditPost(post) {
      this.updatePost = post;
      this.SHOW_EDIT_POST_MODAL = true;
    },

    async getPosts() {
      if (this.searchString.length > 0) {
        return await this.getSearchedPosts();
      } else if (this.searchString.length == 0) {
        return await this.getAllPosts();
      }
    },

    async getForumPosts($state) {
      try {
        if (!$state) {
          this.resetPagination();
        }

        let response = await this.getPosts();

        //Clearing forum posts after fetching new ones to avoid duplicates after searching
        if (!$state) {
          this.forumPosts = [];
        }

        if (response.data && response.data.length) {
          this.hasForms = true;
          this.forumPosts.push(...response.data);
          this.forumPostsPagination.totalPages = response.totalPages;
          this.forumPostsPagination.pageNumber += 1;
          $state && $state.loaded();
          if (!this.searchString) {
            this.setForumPostDataInStore();
          }
        } else {
          $state && $state.complete();
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    SHOW_SEARCH_BAR() {
      if (this.hasForms) return true;

      return this.forumPosts.length || this.searchString;
    },
  },
};
</script>

<style scoped>
.custom-input.IZ-select {
  height: 3em;
  overflow: hidden;
}

/deep/.write-post-modal .modal-dialog {
  width: 100%;
  margin: 0;
  overflow: hidden;
  max-width: none;
}

/deep/.write-post-modal .modal-body {
  height: 100vh;
  padding-top: 16px;
  padding-right: 16px;
  padding-left: 16px;
}

/deep/.write-post-modal-content {
  height: 100vh;
}

/deep/.write-post-modal-content .modal-header button {
  position: static;
}

/deep/.VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}
</style>
>
